export default __webpack_public_path__ + "static/media/movipack_feature5hover.37ad7770.svg";